import React from 'react';
import { ToggleConditionsGlobalContext } from '@Pages/Results/ToggleConditionsGlobalContext';
import ToggleConditionsGlobalProvider from '@Pages/Results/ToggleConditionsGlobal';

export function withToggleConditionsGlobalProvider() {
  return function withToggleConditionsGlobalHOC(Component) {
    return function withToggleConditionsGlobalComponent(props) {
      return (
        <ToggleConditionsGlobalProvider>
          <Component {...props} />
        </ToggleConditionsGlobalProvider>
      );
    };
  };
}

export function withToggleConditionsGlobalConsumer() {
  return function withToggleConditionsGlobalHOC(Component) {
    return function withToggleConditionsGlobalComponent(props) {
      return (
        <ToggleConditionsGlobalContext.Consumer>
          {([showConditions]) => <Component {...props} showConditions={showConditions} />}
        </ToggleConditionsGlobalContext.Consumer>
      );
    };
  };
}
